import React, { useContext, useEffect, useState } from "react";
import { IconButton, Menu, MenuItem, Tooltip } from "@material-ui/core";
import {
  Bot,
  KanbanSquare,
  LayoutDashboard,
  MessagesSquare,
  Tag,
  Zap,
} from "lucide-react";
import { AuthContext } from "../context/Auth/AuthContext";
import { i18n } from "../translate/i18n";
import { WhatsAppsContext } from "../context/WhatsApp/WhatsAppsContext";
import NotificationsPopOver from "../components/NotificationsPopOver";
import ChatPopover from "../pages/Chat/ChatPopover";
import DashboardOutlinedIcon from "@material-ui/icons/DashboardOutlined";
import EventAvailableIcon from "@material-ui/icons/EventAvailable";
import ContactPhoneOutlinedIcon from "@material-ui/icons/ContactPhoneOutlined";
import QuestionAnswerOutlinedIcon from "@material-ui/icons/QuestionAnswerOutlined";
import { Schedule, Description, GridOn } from "@material-ui/icons";
import { Link as RouterLink } from "react-router-dom";
import { Can } from "../components/Can";

export default function AppListItems({ volume }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [selectedSubMenu, setSelectedSubMenu] = useState("");
  const [activeButton, setActiveButton] = useState(null);

  const { user } = useContext(AuthContext);
  const { whatsApps } = useContext(WhatsAppsContext);

  // Estado para controlar se é 'mobile' ou não
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    function handleResize() {
      // Ajuste o número conforme sua necessidade de breakpoint
      setIsMobile(window.innerWidth < 1300);
    }

    window.addEventListener("resize", handleResize);
    handleResize(); // dispara na montagem para verificar o tamanho inicial

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleMenuClick = (event, buttonIndex) => {
    setAnchorEl(event.currentTarget);
    setActiveButton(buttonIndex);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setActiveButton(null);
  };

  const handleSubMenuClick = (submenu, buttonIndex) => {
    setSelectedSubMenu({ [buttonIndex]: submenu });
    handleMenuClose();
  };

  // Tratamento de erro de boundary
  class MyErrorBoundary extends React.Component {
    constructor(props) {
      super(props);
      this.state = { hasError: false };
    }
    static getDerivedStateFromError(error) {
      return { hasError: true };
    }
    componentDidCatch(error, errorInfo) {
      console.log("Error boundary catch:", error, errorInfo);
      // Aqui você pode reportar erros a um serviço externo
    }
    render() {
      if (this.state.hasError) {
        return <h1>Ops! Algo deu errado.</h1>;
      }
      return this.props.children;
    }
  }

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: 5,
        width: "100%",
      }}
    >
      {/* Notificações + Atendimentos */}
      <div style={{ display: "flex", alignItems: "center" }}>
        <MyErrorBoundary>
          <NotificationsPopOver
            volume={volume}
            style={{
              width: "30px",
              height: "25px",
              marginRight: "5px",
            }}
          />
        </MyErrorBoundary>

        <Tooltip title={i18n.t("appBarListem.ticket")}>
          <IconButton
            component={RouterLink}
            to="/tickets"
            size="small"
            style={{
              borderRadius: selectedSubMenu[2] ? 5 : 80,
              paddingInline: selectedSubMenu[2] ? "5px" : 2,
              fontSize: "14px",
              color: "#FFF",
              fontFamily: "Poppins",
              display: "flex",
              alignItems: "center",
              marginLeft: "-3px",
            }}
          >
            {"Atendimentos"}
          </IconButton>
        </Tooltip>
      </div>

      {/* Kanban */}
      <Tooltip title={i18n.t("appBarListem.kanban")}>
        <IconButton
          component={RouterLink}
          to="/kanban"
          size="small"
          style={{
            borderRadius: 80,
            paddingInline: 2,
            fontSize: "14px",
            color: "#FFF",
            fontFamily: "Poppins",
          }}
        >
          <KanbanSquare style={{ width: "30px", height: "25px" }} />
          {"Kanban"}
        </IconButton>
      </Tooltip>

      {/* Contatos */}
      <Tooltip title={i18n.t("appBarListem.contacts")}>
        <IconButton
          component={RouterLink}
          to="/contacts"
          size="small"
          style={{
            borderRadius: 80,
            paddingInline: 2,
            fontSize: "14px",
            color: "#FFF",
            fontFamily: "Poppins",
          }}
        >
          <ContactPhoneOutlinedIcon style={{ width: "30px", height: "25px" }} />
          {"Contatos"}
        </IconButton>
      </Tooltip>

      {/* Agendamentos */}
      <Tooltip title={i18n.t("appBarListem.schedule")}>
        <IconButton
          component={RouterLink}
          to="/schedules"
          size="small"
          style={{
            borderRadius: 80,
            paddingInline: 2,
            fontSize: "14px",
            color: "#FFF",
            fontFamily: "Poppins",
          }}
        >
          <Schedule style={{ width: "30px", height: "25px" }} />
          {"Agendamentos"}
        </IconButton>
      </Tooltip>

      {/* Chat Interno */}
      <div style={{ display: "flex", alignItems: "center" }}>
        <ChatPopover
          style={{
            width: "30px",
            height: "25px",
            marginRight: "5px",
          }}
        />
        <Tooltip title={i18n.t("appBarListem.chats")}>
          <IconButton
            component={RouterLink}
            to="/chats"
            size="small"
            style={{
              borderRadius: selectedSubMenu[2] ? 5 : 80,
              paddingInline: selectedSubMenu[2] ? "5px" : 2,
              fontSize: "14px",
              color: "#FFF",
              fontFamily: "Poppins",
              display: "flex",
              alignItems: "center",
              marginLeft: "-3px",
            }}
          >
            {"Chat Interno"}
          </IconButton>
        </Tooltip>
      </div>

      {/* Tarefas (com texto condicional conforme tela) */}
      <Tooltip title={i18n.t("appBarListem.schedule")}>
        <IconButton
          component={RouterLink}
          to="/todolist"
          size="small"
          style={{
            borderRadius: 80,
            paddingInline: 2,
            fontSize: "14px",
            color: "#FFF",
            fontFamily: "Poppins",
          }}
        >
          <EventAvailableIcon style={{ width: "30px", height: "25px" }} />
          {/* Exibe o texto "Tarefas" somente se não for "mobile" */}
          {!isMobile && "Tarefas"}
        </IconButton>
      </Tooltip>

      {/* Gerência (com texto condicional conforme tela) */}
      {user && (
        <Can
          role={
            (user.profile === "user" && user.showDashboard === "enabled") ||
              user.allowRealTime === "enabled"
              ? "admin"
              : user.profile
          }
          perform={"drawer-admin-items:view"}
          yes={() => (
            <Tooltip title={i18n.t("appBarListem.reports")}>
              <IconButton
                size="small"
                style={{
                  borderRadius: 80,
                  paddingInline: 2,
                  fontSize: "14px",
                  color: "#FFF",
                  fontFamily: "Poppins",
                }}
                onClick={(event) => handleMenuClick(event, 2)}
              >
                <LayoutDashboard style={{ width: "30px", height: "25px" }} />
                {/* Exibe o texto "Gerência" somente se não for "mobile" */}
                {!isMobile && <span>Gerência</span>}
              </IconButton>
            </Tooltip>
          )}
        />
      )}

      {/* Menu suspenso de Gerência */}
      <Menu
        anchorEl={anchorEl}
        keepMounted
        getContentAnchorEl={null}
        open={activeButton === 2}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <div
          style={{
            margin: "-5px 5px",
            display: "flex",
            backgroundColor: "transparent",
            justifyContent: "center",
          }}
        >
          <Can
            role={
              user.profile === "user" && user.showDashboard === "enabled"
                ? "admin"
                : user.profile
            }
            perform={"drawer-admin-items:view"}
            yes={() => (
              <>
                <MenuItem
                  component={RouterLink}
                  to="/"
                  onClick={handleMenuClose}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100px",
                    textAlign: "center",
                    margin: "0 auto",
                  }}
                >
                  <DashboardOutlinedIcon
                    style={{ fontSize: "25px", marginBottom: "4px" }}
                  />
                  <span style={{ fontSize: "12px" }}>Dashboard</span>
                </MenuItem>
                <MenuItem
                  component={RouterLink}
                  to="/reports"
                  onClick={handleMenuClose}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100px",
                    textAlign: "center",
                    margin: "0 auto",
                  }}
                >
                  <Description
                    style={{ fontSize: "25px", marginBottom: "4px" }}
                  />
                  <span style={{ fontSize: "12px" }}>Relatórios</span>
                </MenuItem>
              </>
            )}
          />
          <Can
            role={
              user.profile === "user" && user.allowRealTime === "enabled"
                ? "admin"
                : user.profile
            }
            perform={"drawer-admin-items:view"}
            yes={() => (
              <MenuItem
                component={RouterLink}
                to="/moments"
                onClick={handleMenuClose}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100px",
                  textAlign: "center",
                  margin: "0 auto",
                }}
              >
                <GridOn style={{ fontSize: "25px", marginBottom: "4px" }} />
                <span
                  style={{
                    fontSize: "12px",
                    wordWrap: "break-word",
                    whiteSpace: "normal",
                  }}
                >
                  Painel de Atendimentos
                </span>
              </MenuItem>
            )}
          />
        </div>
      </Menu>
    </div>
  );
}
